import React, { useEffect, useState } from "react";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import "survey-core/defaultV2.min.css";
import { themeJson } from "./theme";
import "./index.css";

function SurveyComponent() {
    const [surveyModel, setSurveyModel] = useState(null);

    useEffect(() => {
        // Fetch the survey definition
        fetch('https://surveysocket-sample.azurewebsites.net/api/surveys/1240214753150763008/surveyDefinition')
            .then(response => response.json())
            .then(data => {
                const surveyJson = JSON.parse(data.jsonData);
                const survey = new Model(surveyJson);
                survey.applyTheme(themeJson);
                survey.onComplete.add((sender, options) => {
                    console.log(JSON.stringify(sender.data, null, 3));

                    fetch('https://surveysocket-sample.azurewebsites.net/api/surveys/1240214753150763008/responses', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ jsonData: JSON.stringify(sender.data) })
                    })
                    .then(response => response.json())
                    .then(data => console.log('Success:', data))
                    .catch((error) => console.error('Error:', error));
                });
                setSurveyModel(survey);
            })
            .catch((error) => console.error('Error fetching survey definition:', error));
    }, []);

    return (
        surveyModel ? <Survey model={surveyModel} /> : <div>Loading...</div>
    );
}

export default SurveyComponent;
